module.exports = __webpack_public_path__ + "static/media/bu-summary-PM.80c6abfc.svg";